import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { FormikProps } from "formik";
import { Grid2 } from "@mui/material";
import { useAuth } from "src/context/auth";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "src/utilities";
import { IProvince } from "src/interface/IProvince";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";

export default function SelectCity({
  formik,
  provinceSize = 3,
  citySize = 3,
  size = "medium",
}: {
  formik: FormikProps<any>;
  provinceSize?: number;
  citySize?: number;
  size?: "small" | "medium";
}) {
  const { user } = useAuth();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["ProvincesData"],
    queryFn: () =>
      fetch(API_URL + "provinces", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [getProvinces, setProvinces] = React.useState<
    IAutoCompleteLabelValue[]
  >([]);

  const [getCities, setCities] = React.useState<IAutoCompleteLabelValue[]>([]);
  React.useEffect(() => {
    if (data) {
      setProvinces(
        data.map((item: IProvince) => ({
          label: item.name,
          value: item.id,
        }))
      );
    }
  }, [data]);

  React.useEffect(() => {
    if (getProvinces) {
      const cities = data?.find(
        (prov: IProvince) => prov.id === formik?.values?.provinceId
      );

      if (cities)
        setCities(
          cities?.cities?.map((item: IProvince) => ({
            label: item.name,
            value: item.id,
          }))
        );
    }
  }, [formik?.values?.provinceId, getProvinces]);
  return (
    <>
      <Grid2 size={provinceSize}>
        <Autocomplete
          loading={isLoading}
          disablePortal
          key={"province"}
          value={
            getProvinces.find((p) => p.value === formik.values.provinceId) ||
            null
          }
          onChange={(event: any, newValue: any) => {
            formik.setFieldValue("provinceId", newValue?.value || undefined);
          }}
          size={size}
          options={getProvinces}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              error={
                formik.touched.provinceId && Boolean(formik.errors.provinceId)
              }
              helperText={
                (formik.touched.provinceId &&
                  formik.errors.provinceId) as boolean
              }
              label="استان"
            />
          )}
        />
      </Grid2>
      <Grid2 size={citySize}>
        <Autocomplete
          loading={isLoading}
          disablePortal
          key={"city"}
          value={
            getCities.find((c) => c.value === formik.values.cityId) || null
          }
          onChange={(event: any, newValue: any) => {
            formik.setFieldValue("cityId", newValue?.value || undefined);
          }}
          size={size}
          options={getCities}
          fullWidth
          renderInput={(params) => (
            <TextField
              error={formik.touched.cityId && Boolean(formik.errors.cityId)}
              helperText={
                (formik.touched.cityId && formik.errors.cityId) as boolean
              }
              {...params}
              label="شهر"
            />
          )}
        />
      </Grid2>
    </>
  );
}
